import { render, staticRenderFns } from "./FinancialBatchDetail.vue?vue&type=template&id=ca949c48&scoped=true&"
import script from "./FinancialBatchDetail.vue?vue&type=script&lang=js&"
export * from "./FinancialBatchDetail.vue?vue&type=script&lang=js&"
import style0 from "./FinancialBatchDetail.vue?vue&type=style&index=0&id=ca949c48&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca949c48",
  null
  
)

export default component.exports